import { useState } from "react";
import { Modal, IconPicker, RequestIcon, Glyph, Chk } from "../ui";
import { Button } from "../ui/ds";
import { BuzerIcon } from "../../BuzerIcons";
import { iconChipStyle } from "../../lib/icons-resolve";
import { APP_THEME_SWATCHES } from "../../lib/constants";

// Shared icon + background-colour picker modal used by every create/edit form.
// The choice is a DRAFT — it only applies to the parent when the user taps Hotovo
// (closing with × reverts). The header chip previews the live draft.
//   onIcon(name) / onColor(hex) — committed on Hotovo
//   onAiIcon — optional async () => the suggested icon name (shown as a header spark)
export function IconColorModal({ icon, iconColor, fallback = "target", onIcon, onColor, onClose, onAiIcon, onCommit }) {
  const [dIcon, setDIcon] = useState(icon || "");
  const [dColor, setDColor] = useState(iconColor || "");
  const [aiBusy, setAiBusy] = useState(false);
  const [saving, setSaving] = useState(false);
  // onCommit (edit mode) persists the icon+colour to the DB right on Hotovo,
  // independent of the surrounding form's save.
  async function commit() {
    onIcon(dIcon); onColor(dColor);
    if (onCommit) { setSaving(true); try { await onCommit(dIcon, dColor); } catch (e) { /* */ } setSaving(false); }
    onClose();
  }
  return (
    <Modal title="Vyber ikonu" iconNode={<Glyph icon={dIcon || fallback} size={20} />} iconStyle={iconChipStyle(dColor)} onClose={onClose}
      headerAction={onAiIcon ? (
        <button type="button" disabled={aiBusy} title="Navrhni ikonu (AI)" aria-label="Navrhni ikonu"
          onClick={async () => { setAiBusy(true); try { const nm = await onAiIcon(); if (nm) setDIcon(nm); } catch (e) { /* */ } setAiBusy(false); }}
          style={{ border: "none", background: "transparent", color: "var(--accent)", display: "inline-flex", alignItems: "center", cursor: "pointer", padding: 4 }}>
          <BuzerIcon name="sparkles" size={18} color="currentColor" />
        </button>
      ) : null}>
      <div style={{ marginBottom: 14 }}>
        <div className="bz-field__label">Farba pozadia</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          <button type="button" onClick={() => setDColor("")} aria-label="Predvolená farba" title="Predvolená"
            style={{ width: 30, height: 30, borderRadius: 99, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--field)", border: dColor === "" ? "2px solid var(--text)" : "1.5px solid var(--field-border)" }}>
            {dColor === "" ? <Chk /> : null}
          </button>
          {APP_THEME_SWATCHES.map(([nm, hex]) => (
            <button type="button" key={nm} onClick={() => setDColor(hex)} aria-label={nm} title={nm}
              style={{ width: 30, height: 30, borderRadius: 99, cursor: "pointer", background: hex, border: dColor === hex ? "2px solid var(--text)" : "1.5px solid transparent" }} />
          ))}
        </div>
      </div>
      <IconPicker value={dIcon} onPick={setDIcon} hideRequest />
      <div style={{ position: "sticky", bottom: 0, background: "var(--surface-solid)", paddingTop: 10, marginTop: 4 }}>
        <Button variant="primary" block onClick={commit} disabled={saving}>{saving ? "…" : "Hotovo"}</Button>
      </div>
      <RequestIcon />
    </Modal>
  );
}
